import { render } from "./FunctionsCatalogDatatable.vue?vue&type=template&id=b6f8ca18&ts=true"
import script from "./FunctionsCatalogDatatable.vue?vue&type=script&lang=ts"
export * from "./FunctionsCatalogDatatable.vue?vue&type=script&lang=ts"

import "./FunctionsCatalogDatatable.vue?vue&type=style&index=0&id=b6f8ca18&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__